var exports = {
  "qr": "footer__Y-9jqy",
  "AS": "item__jW_God",
  "Pf": "label__88o0QS",
  "Uq": "value__PBByZE",
};

module.exports = exports;
